import React from "react";
import { Plane, Briefcase, Dumbbell, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const scenarios = [{
  id: "royal-experience",
  title: "Královská Péče",
  subtitle: "Vrchol smyslného luxusu",
  description: "Pro ty, kteří hledají absolutní exkluzivitu. Čtyřruční masáž prováděná dvěma terapeutkami v dokonalé synchronizaci. Tento rituál je navržen tak, aby zcela vypnul vaši mysl a přenesl vás do stavu čisté euforie, kde se hranice mezi realitou a snem začínají stírat.",
  image: "https://wired-magpie.10web.cloud/wp-content/uploads/2026/05/Screenshot_1.jpg?v=cmeym604pbv",
  imageAlt: "Elegantní interiér salonu s hedvábnými texturami a měkkým světlem",
  proTipTitle: "Párová Harmonie",
  proTipText: "Tento zážitek lze objednat i jako společný rituál pro páry, které chtějí sdílet okamžiky hlubokého propojení.",
  icon: Briefcase,
  reverse: true
}, {
  id: "body-to-body",
  title: "Body-to-Body",
  subtitle: "Intimní kontakt a teplo",
  description: "Nejtěsnější spojení, které naše nabídka umožňuje. Masáž celým tělem využívá přirozené teplo a kluzké oleje k vytvoření nezapomenutelného zážitku. Je to tanec kůže na kůži, který probouzí skryté touhy a přináší pocit naprostého přijetí a uvolnění napětí.",
  image: "https://wired-magpie.10web.cloud/wp-content/uploads/2026/05/Screenshot_2.jpg?v=ljd4z4b1xuo",
  imageAlt: "Warm indoor lighting highlighting high‑quality massage oils in elegant bottles, heated stones, and folded luxury towels on a surface, creating a clean, inviting, high‑end sensual massage atmosphere without people",
  proTipTitle: "Délka Prožitku",
  proTipText: "Pro plné rozvinutí všech fází tohoto rituálu doporučujeme zvolit variantu 90 minut, která umožní postupné gradování.",
  icon: Dumbbell,
  reverse: false
}];
export default function ScenariosOfSuccess() {
  return <section data-section-id="241041" id="rituály-rozkoše" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {}
        <div className="max-w-3xl mx-auto text-center mb-20 lg:mb-32">
          <div className="inline-flex items-center justify-center gap-2 mb-4">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm font-default font-medium tracking-widest uppercase text-muted-foreground">
              Umění Intimity
            </span>
            <Sparkles className="w-4 h-4 text-primary" />
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light tracking-tight mb-6">
            Rituály rozkoše
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default max-w-2xl mx-auto">
            Navrženo pro náročné muže hledající únik z každodennosti. Objevte, jak SENSU transformuje péči o tělo v nezapomenutelný smyslový zážitek.
          </p>
        </div>

        {}
        <div className="flex flex-col gap-24 lg:gap-40">
          {scenarios.map((scenario, i) => {
          const Icon = scenario.icon;
          return <div key={scenario.id} data-index={i} className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                {}
                <div className={`order-1 ${scenario.reverse ? "lg:order-2" : "lg:order-1"}`}>
                  <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl shadow-2xl bg-muted/20 border border-primary/10">
                    
                    <img src={scenario.image} alt={scenario.imageAlt} className="w-full h-full object-cover object-center transition-transform duration-1000 hover:scale-110" loading="lazy" />
                  </div>
                </div>

                {}
                <div className={`order-2 flex flex-col justify-center ${scenario.reverse ? "lg:order-1" : "lg:order-2"}`}>
                  <div className="mb-8">
                    <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-6 border border-primary/20">
                      <Icon className="w-6 h-6" />
                    </div>
                    <h3 className="text-3xl md:text-4xl font-serif font-medium mb-3 text-foreground">
                      {scenario.title}
                    </h3>
                    <p className="text-xl text-primary/90 font-serif italic mb-6">
                      {scenario.subtitle}
                    </p>
                    <p className="text-muted-foreground text-lg leading-loose font-default">
                      {scenario.description}
                    </p>
                  </div>

                  {}
                  <Card className="bg-card/30 backdrop-blur-md border-primary/20 shadow-xl shadow-black/20">
                    <CardHeader className="pb-3">
                      <CardTitle className="text-sm font-default tracking-widest uppercase text-primary flex items-center gap-2">
                        <span className="w-8 h-[1px] bg-primary/40 inline-block" />
                        Detail zážitku
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <h4 className="text-lg font-serif font-medium mb-2 text-foreground">
                        {scenario.proTipTitle}
                      </h4>
                      <p className="text-muted-foreground leading-relaxed font-default text-sm md:text-base">
                        {scenario.proTipText}
                      </p>
                    </CardContent>
                  </Card>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}